module.exports = __webpack_public_path__ + "img/skills.d31f15a2.svg";